import { POST } from 'utils/fetchWrappers';
import { API_VIEW_KYC_DOCUMENT } from 'utils/API/apiUrls';
import { apiStatusCodes } from 'utils/API/apiStatusCodes';
import { ERROR_MESSAGES } from 'utils/constants/toastMessages';

import { KYC_FIELD_NAME_TO_TITLE_MAP } from 'utils/constants/commonValues';

import React from 'react';
import PropTypes from 'prop-types';
import { toast } from 'react-toastify';
import { isEmpty } from 'lodash';

const KYCView = props => {
    const { data } = props;

    async function handleViewClick(docUrl) {
        const request = {
            s3Path: docUrl,
        };
        try {
            const response = await POST(
                API_VIEW_KYC_DOCUMENT,
                request,
                {},
                true
            );
            const { data } = response;
            if (data && data.statusCode === apiStatusCodes.SUCCESS) {
                window.open(data.s3Url, '_blank');
            } else {
                toast.error(ERROR_MESSAGES.FALLBACK_ERROR);
            }
        } catch (error) {
            toast.error(ERROR_MESSAGES.FALLBACK_ERROR);
        }
    }

    const { additionalDocs } = data;
    const simpleFields = (({ additionalDocs, ...rest }) => rest)(data);

    return (
        <>
            <div className="checker-section-container">
                <h1 className="checker-section-title">KYC Section Data</h1>
                <div className="form-section">
                    {Object.keys(simpleFields).map((fieldName, index) => {
                        if (
                            !data[fieldName] ||
                            !KYC_FIELD_NAME_TO_TITLE_MAP[fieldName]
                        ) {
                            return null;
                        }
                        return (
                            <>
                                <div className={`form-field`} key={index}>
                                    <p className="label">
                                        {KYC_FIELD_NAME_TO_TITLE_MAP[fieldName]}
                                    </p>
                                    <p className="user-text">
                                        <button
                                            className="view"
                                            onClick={() =>
                                                handleViewClick(data[fieldName])
                                            }
                                        />
                                    </p>
                                </div>
                            </>
                        );
                    })}
                    {Object.keys(additionalDocs).map((fieldName, index) => {
                        if (
                            !additionalDocs[fieldName] ||
                            isEmpty(additionalDocs[fieldName].filter(Boolean))
                        ) {
                            return null;
                        }
                        return (
                            <>
                                <div className={`form-field`} key={index}>
                                    <p className="label">{fieldName}</p>
                                    {additionalDocs[fieldName].map(
                                        (additionalDoc, additionalDocIndex) => {
                                            if (!additionalDoc) {
                                                return null;
                                            }
                                            return (
                                                <p
                                                    className="user-text"
                                                    key={additionalDocIndex}
                                                >
                                                    <button
                                                        className="view"
                                                        onClick={() =>
                                                            handleViewClick(
                                                                additionalDoc
                                                            )
                                                        }
                                                    />
                                                </p>
                                            );
                                        }
                                    )}
                                </div>
                            </>
                        );
                    })}
                </div>
            </div>
        </>
    );
};

KYCView.propTypes = {
    data: PropTypes.object,
};

export default KYCView;
